import { apiFetch } from "./api";

export interface NotesDto {
  note: string | null;
  rowVersionBase64: string | null;
}

export interface ExtraNotesDto {
  extraNote: string | null;
  rowVersionBase64: string | null;
}

export interface UpdateNotesRequest {
  note: string;
  rowVersionBase64: string;
}

export const quoteNotesApi = {
  getNotes:      (quoteId: number) => apiFetch<NotesDto>(`/api/quotes/${quoteId}/notes`),
  putNotes:      (quoteId: number, body: UpdateNotesRequest) =>
    apiFetch<NotesDto>(`/api/quotes/${quoteId}/notes`, { method: "PUT", body: JSON.stringify(body) }),
  getExtraNotes: (quoteId: number) => apiFetch<ExtraNotesDto>(`/api/quotes/${quoteId}/extra-notes`),
  putExtraNotes: (quoteId: number, body: UpdateNotesRequest) =>
    apiFetch<ExtraNotesDto>(`/api/quotes/${quoteId}/extra-notes`, { method: "PUT", body: JSON.stringify(body) }),
};
